import { Injectable, signal } from '@angular/core';

export type ToastTone = 'success' | 'warning' | 'error';

export interface ToastItem {
  id: number;
  tone: ToastTone;
  message: string;
  durationMs: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 1;

  readonly toasts = signal<ToastItem[]>([]);

  showSuccess(message: string, durationMs = 4000): void {
    this.show('success', message, durationMs);
  }

  showWarning(message: string, durationMs = 5000): void {
    this.show('warning', message, durationMs);
  }

  showError(message: string, durationMs = 6000): void {
    this.show('error', message, durationMs);
  }

  dismiss(id: number): void {
    this.toasts.update((items) => items.filter((item) => item.id !== id));
  }

  private show(tone: ToastTone, message: string, durationMs: number): void {
    const normalizedMessage = message.trim();
    if (!normalizedMessage) {
      return;
    }

    const id = this.nextId++;
    this.toasts.update((items) => [...items, { id, tone, message: normalizedMessage, durationMs }]);

    globalThis.setTimeout(() => this.dismiss(id), durationMs);
  }
}
